import React from "react";

import {
  getVideoThumbnailImage,
  YouTubeThumbnailQuality,
} from "../utils/component";

export type ThumbnailOptions = {
  youtubeQuality?: YouTubeThumbnailQuality;
};

export function useThumbnail(
  src: string,
  options: ThumbnailOptions = {
    youtubeQuality: "mqdefault",
  },
) {
  const [thumbnail, setThumbnail] = React.useState(src);

  React.useEffect(() => {
    async function updateThumbnail() {
      if (!src) {
        setThumbnail(null);
        return;
      }

      const value = await getVideoThumbnailImage(src, options.youtubeQuality);

      if (value !== thumbnail) {
        setThumbnail(value);
      }
    }

    updateThumbnail();
  }, [src, thumbnail]);

  return thumbnail;
}
